import { faMoneyBill } from "@fortawesome/free-solid-svg-icons";
import DataTable from "react-data-table-component";
import { useHistory } from "react-router-dom";
import ConfigService from "../../../services/configuracion/ConfigService";
import ButtonLink from "../../generico/ButtonLink";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SepelioDetalle } from "./SepelioDetalle";

const PAGAR_SEPELIO = 108;

export const Sepelio = ({ data }) => {

    const history = useHistory();

    const getColumn = () => {
        return [
            {
                name: "Nro. de Solicitud",
                selector: row => row.idSolicitud,
                // right: true
            },
            {
                name: "Empresa",
                selector: row => row.nombreEmpresa,
                // right: true
            },
            {
                name: "Fecha de Pagare",
                selector: row => row.fechaPagare,
                right: true
            },
            {
                name: "Fecha de Vencimiento",
                selector: row => row.fechaVencimiento,
                right: true
            },
            {
                name: "Monto a Pagar",
                selector: row => formatoSeparadorMilesValue(row.montoAPagar),
                right: true
            },
            {
                cell: (row) => (
                    <ButtonLink
                        className="btn btn-cu-secundary btn-sm"
                        onClick={pagarSepelio}
                        url={ConfigService.getPathById(PAGAR_SEPELIO)?.url}
                        param={row}>
                        <FontAwesomeIcon icon={faMoneyBill} /> Pagar
                    </ButtonLink>
                ),

            }
        ];
    }

    const pagarSepelio = (url, param) => {
        history.push(url, { param });
    }

    return (
        <div className="table-responsive">
            <DataTable
                noHeader={true}
                pagination={false}
                columns={getColumn()}
                data={data}
                noDataComponent="no hay registros para mostrar"
                responsive={true}
                expandableRows={true}
                expandableRowsComponent={SepelioDetalle}
                expandableRowDisabled={row => row.disabled}
                expandableRowsComponentProps={{ detalle: data }}
            />
        </div>
    )
}